(function ($, Global) {
    var TagPage = function () {
        // Déclaration class objet
    }

    TagPage.prototype.initEvents = function () {
        this.publishers();
    }

    TagPage.prototype.publishers = function () {
        $(document).ready(function () {
            if ($('.page-tag').hasClass('with-illustration')) return;

            var $sidenav = $('.sidenav');
            var $title = $('h1');

            var offsetDiff = $title.offset().top - $sidenav.offset().top + 8;

            $sidenav.css('margin-top', offsetDiff + 'px');
        });
    }

    Global.TagPage = TagPage;
}(jQuery, window));